import React from 'react';
import { StyleSheet, View } from 'react-native';
import TitledView from 'design-system/TitledView';
import { Chip } from 'design-system/Chip';
import DayOfTheWeekPicker from 'design-system/day-of-the-week-picker/DayOfTheWeekPicker';
import { Spacer } from 'design-system';
const chips = [
    {
        id: 1,
        text: '1st',
    },
    {
        id: 2,
        text: '2nd',
    },
    {
        id: 3,
        text: '3rd',
    },
    {
        id: 4,
        text: '4th',
    },
    {
        id: 5,
        text: 'Last',
    },
];
const EveryMonthView = ({ selectedDay, onSelectDay, weekNumber, setWeekNumber, }) => {
    const onTheWeekChipsRow1 = React.useMemo(() => chips.slice(0, 3).map((co, i) => (<Chip key={co.id} text={co.text} id={co.id} BrandOutline={weekNumber === co.id} type="squared" style={[styles.chip, i === chips.length - 1 && styles.lastChip]} onPress={() => {
            setWeekNumber(co.id);
        }}/>)), [setWeekNumber, weekNumber]);
    const onTheWeekChipsRow2 = React.useMemo(() => chips.slice(3).map((co, i) => (<Chip key={co.id} text={co.text} id={co.id} BrandOutline={weekNumber === co.id} type="squared" style={[styles.chip, i === chips.length - 1 && styles.lastChip]} onPress={() => {
            setWeekNumber(co.id);
        }}/>)), [setWeekNumber, weekNumber]);
    return (<View>
      <TitledView title="On the">
        <View style={styles.chipsContainer}>{onTheWeekChipsRow1}</View>
        <Spacer.H16 />
        <View style={styles.chipsContainer}>{onTheWeekChipsRow2}</View>
      </TitledView>
      <Spacer.H8 />
      <DayOfTheWeekPicker selectedDay={selectedDay} onSelectDay={onSelectDay}/>
    </View>);
};
const styles = StyleSheet.create({
    chipsContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    chip: {
        flex: 1 / 3,
    },
    lastChip: {
        marginEnd: 0,
    },
});
export default EveryMonthView;
